<template>
  <div
    class="product-additional-information"
    id="shipping"
  >
    <accordion
      ref="accordion"
      class="product-additional-information__accordion"
      :is-content-html="true"
      :id="id"
      :name="$t('ads.main.shipping.cost.headline')"
    >
      <div class="product-additional-information__content | html-teaser">
        <span class="product-additional-information__info">{{ $t('ads.main.shipping.cost.info') }}</span>
        <span class="product-additional-information__info">{{ $t('ads.main.shipping.cost.info2') }}</span>
      </div>
    </accordion>
  </div>
</template>
<script>
  import Accordion from '../accordion/accordion.vue';

  export default {
    components: {
      Accordion
    },
    props: {
      id: String
    },
    methods: {
      openAccordion() {
        this.$refs.accordion.open();
      }
    }
  };

</script>
